module.exports = __webpack_public_path__ + "static/media/S1N11-6.ce2c92e4.svg";